import React from "react";
import "./Footer.css";
import logo from "../assets/logo.png";
import carbon from "../assets/carboncc.png";
import { MdOutlineMail } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="footer text-light py-4 mt-5">
      <div className="container">
        <div className="row align-items-center text-center text-md-start">
          {/* Left Section */}
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <img src={logo} alt="YPO Logo" className="footer-logo me-2" />
              <div>
                <h5 className="mb-1">YPO Flight Carbon Calculator</h5>
                <small>
                  Together, we’re building a sustainable future for business
                  travel.
                </small>
              </div>
            </div>
          </div>

          {/* Center Section */}
          <div className="col-md-4 mb-3 mb-md-0 text-center">
            <div className="powered-by">
              <img
                src={carbon}
                alt="BlocCarbon Logo"
                width="36"
                className="me-2"
              />
              <br />
              <small>Powered by BlocCarbon</small>
            </div>
          </div>

          {/* Right Section */}

          <div className="col-md-4 text-center text-md-end">
            <div className="contact-info">
              <div className="d-flex align-items-center justify-content-center justify-content-md-end mb-2">
                <MdOutlineMail className="footer-icon" />
                <a
                  href="mailto:sam@bloccarbon.com"
                  className="text-light text-decoration-none ms-2"
                >
                  support@ypocarboncalculator.com
                </a>
              </div>
              {/* <div className="d-flex align-items-center justify-content-center justify-content-md-end mb-2">
                <FaPhone className="footer-icon" />
                <span className="ms-2">+1 (555) 123-44</span>
              </div> */}
              {/* <div className="d-flex align-items-center justify-content-center justify-content-md-end">
                <IoLocation className="footer-icon" />
                <span className="ms-2">New York, NYMK</span>
              </div> */}
            </div>
          </div>
        </div>

        {/* Horizontal Line */}
        <hr className="custom-line" />

        {/* Bottom Line */}
        <div className="text-center mt-4">
          <small>
            © {new Date().getFullYear()} YPO | BlocCarbon App. All rights
            reserved.
          </small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
